import React, { useState, useEffect } from "react";
import bsBreakpoints from "bs-breakpoints";
import classNames from "classnames";
import PageSection from "../PageSection/PageSection";
import ResponsivePageHeader from "../ResponsivePageHeader/ResponsivePageHeader";
import { Col, Row, Image } from "react-bootstrap";

const SeminarGallaryResponsive = () => {
	const [currentBreakPoint, setCurrentBreakPoint] = useState("");

	useEffect(() => {
		bsBreakpoints.init();
		setCurrentBreakPoint(bsBreakpoints.getCurrentBreakpoint());

		const handleBreakPoint = (event) => {
			setCurrentBreakPoint(event.detail);
		};

		window.addEventListener("new.bs.breakpoint", handleBreakPoint);

		return () => {
			window.removeEventListener("new.bs.breakpoint", handleBreakPoint);
		};
	}, []);

	const descriptionClasses = classNames("mb-4 text-center text-text-color", {
		"font-sm": currentBreakPoint === "xSmall" || currentBreakPoint === "small",
	});

	return (
		<PageSection>
			<ResponsivePageHeader title="Gallery" />
			<Row className="justify-content-center">
				<Col md="4" className="mb-4">
					<Image
						src={require("../../assets/seminar-hall/sem1.JPG").default}
						className="img-fluid rounded mb-4 image-coverfit"
					/>
				</Col>
				<Col md="4" className="mb-4">
					<Image
						src={require("../../assets/seminar-hall/sem2.JPG").default}
						className="img-fluid rounded mb-4 image-coverfit"
					/>
				</Col>
				<Col md="4" className="mb-4">
					<Image
						src={require("../../assets/seminar-hall/sem3.JPG").default}
						className="img-fluid rounded mb-4 image-coverfit"
					/>
				</Col>
				<Col md="4" className="mb-4">
					<Image
						src={require("../../assets/seminar-hall/seminar (1).JPG").default}
						className="img-fluid rounded mb-4 image-coverfit"
					/>
				</Col>
				<Col md="4" className="mb-4">
					<Image
						src={require("../../assets/seminar-hall/seminar (2).JPG").default}
						className="img-fluid rounded mb-4 image-coverfit"
					/>
				</Col>
				<Col md="4" className="mb-4">
					<Image
						src={require("../../assets/seminar-hall/seminar (3).JPG").default}
						className="img-fluid rounded mb-4 image-coverfit"
					/>
				</Col>
				<Col md="4" className="mb-4">
					<Image
						src={require("../../assets/seminar-hall/seminar (4).JPG").default}
						className="img-fluid rounded mb-4 image-coverfit"
					/>
				</Col>
				<Col md="4" className="mb-4">
					<Image
						src={require("../../assets/seminar-hall/seminar (5).JPG").default}
						className="img-fluid rounded mb-4 image-coverfit"
					/>
				</Col>
			</Row>
		</PageSection>
	);
};

export default SeminarGallaryResponsive;
